import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { usePopup } from '../contexts/PopupContext';

import styled from 'styled-components';
import { FormWrapper, Label, Select, Button, Input } from '../forms/shared_form_styles';
import { NameWrapper, Row, Column, ButtonSection, InfoLabel, InputName, NavButton, Column25 } from '../forms/shared_details_form_styles';
import { faPlus, faPercent, faHandHoldingDollar, faEye, faPen, faPlay, faStop, faTableList, faUser, faListCheck, faFileCirclePlus, faMagnifyingGlass, faBook, faFileCircleCheck, faTrashCan, faCertificate, faCircleCheck,faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Wrapper, Header, H2, IconButton } from './shared_pages_styles';
import { TableSection, H4, Table, Th, Td, Tr, TableIconButton } from '../table_styles';
import AddPaymentRecord from '../forms/AddPaymentRecord';
import SetTuitionValues from '../forms/SetTuitionValues';
import LoadingSpinner from '../components/LoadingSpinner';

import { deletePayment, setPaymentRecords } from '../actions/paymentRecordActions';
import { deleteStudent, setStudents } from '../actions/studentActions';



export const Payments = () => {
  const paymentsArray = useSelector((state) =>
    state.paymentRecords ? state.paymentRecords : null
  );
  const studentsArray = useSelector((state) =>
  state.students ? state.students : null);


  const [filteredPayments, setFilteredPayments] = useState("");
  const [studentOptions, setStudentOptions] = useState([]);

  const [selectedStudent, setSelectedStudent] = useState('All');
  const [selectedType, setSelectedType] = useState('All');
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);
  const [selectedDateUntill, setSelectedDateUntill] = useState(null);

  const typesArray = ['Payment', 'Charge', 'All'];
  const { openPopup } = usePopup();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    const today = new Date();
    const prevMonthFirstDay = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    setSelectedDateFrom(prevMonthFirstDay.toISOString());
    setSelectedDateUntill(today.toISOString());
    if (!paymentsArray || paymentsArray?.length == 0) {
    dispatch(setPaymentRecords());
  }
    if (!studentsArray || studentsArray?.length == 0) {
      dispatch(setStudents());
    }
  }, []);
  useEffect(() => {
    const options = [...paymentsArray.filter((payment, index, self) =>
      index === self.findIndex((t) => (
        t.student.name === payment.student.name
      ))
    ).map(payment => payment.student.name
    ), 'All'];
    setStudentOptions(options);
  }, [paymentsArray]);
  useEffect(() => {
    let filteredPayments = [];
    if (paymentsArray && paymentsArray.length > 0) {
      filteredPayments = paymentsArray.filter(payment =>
        (payment.student.name == selectedStudent || selectedStudent == 'All') &&
        ((payment.amount < 0 && selectedType == 'Charge') || (payment.amount > 0 && selectedType == 'Payment') || (selectedType == 'All')) &&
        ((new Date(payment.paymentDate) <= new Date(selectedDateUntill)) && (new Date(payment.paymentDate) >= new Date(selectedDateFrom)))
      );
      setFilteredPayments(filteredPayments);
    }
  }, [paymentsArray, selectedStudent, selectedType, selectedDateFrom, selectedDateUntill]);
  const handleEditPayment = (payment) => {
    openPopup(<AddPaymentRecord payment={payment} />);
  };
  const handleDeletePayment = (paymentId) => { dispatch(deletePayment(paymentId)); };
  const handlePay = () => {
    openPopup(<AddPaymentRecord />);
  };
  const handleChangesOnPrices=()=>{
    openPopup(<SetTuitionValues />);
  };

  if (studentsArray.length == 0) {
    return <LoadingSpinner />;
  }

  return (
    <Wrapper>
      <Header>
        <H2>Registros de Movimientos</H2>
        <ButtonSection>

          <IconButton onClick={() => handlePay()}><FontAwesomeIcon icon={faHandHoldingDollar} /></IconButton>
          <IconButton onClick={() => handleChangesOnPrices()}><FontAwesomeIcon icon={faDollarSign} /></IconButton>
        </ButtonSection>
      </Header>
      <Row>
        <Column25>
          <Label>
            Student:
            <Select
              value={selectedStudent}
              onChange={(e) => { setSelectedStudent(e.target.value) }}
            >
              {studentOptions.map((item, index) => (
                <option key={index} value={item}>{item}</option>
              ))}
            </Select>
          </Label>

        </Column25>
        <Column25>
          <Label>
            Date from:
            <Input
              type="date"
              name="dateFrom"
              value={selectedDateFrom !== null ? selectedDateFrom.split('T')[0] : ''}
              onChange={(e) => { setSelectedDateFrom(e.target.value) }}
            />
          </Label>
        </Column25>
        <Column25>

          <Label>
            Date until:
            <Input
              type="date"
              name="dateUntill"
              value={selectedDateUntill !== null ? selectedDateUntill.split('T')[0] : ''}
              onChange={(e) => { setSelectedDateUntill(e.target.value) }}
            />
          </Label>
        </Column25>
        <Column25>

          <Label>
            Type:
            <Select
              value={selectedType}
              onChange={(e) => { setSelectedType(e.target.value) }}
            >
              {typesArray.map((item, index) => (
                <option key={index} value={item}>{item}</option>
              ))}
            </Select>
          </Label>
        </Column25>
      </Row>
      <TableSection>
        <Table>
          <thead>
            <Tr>
              <Th>Student</Th>
              <Th>Date </Th>
              <Th>Type </Th>
              <Th>Currency</Th>
              <Th>Amount</Th>
              <Th>Actions</Th>
            </Tr>
          </thead>
          <tbody>
            {filteredPayments && filteredPayments.map((payment, index) => (
              <Tr key={index}>
                <Td>{payment.student.name}</Td>
                <Td>{payment.paymentDate && payment.paymentDate.split('T')[0]}</Td>
                <Td>{payment.amount > 0 ? "Payment" : "Charge"}</Td>
                <Td>{payment.currency}</Td>
                <Td>{payment.amount}</Td>
                <Td>
                  <TableIconButton onClick={() => handleDeletePayment(payment._id)}><FontAwesomeIcon icon={faTrashCan} /></TableIconButton>
                  <TableIconButton onClick={() => handleEditPayment(payment)}><FontAwesomeIcon icon={faPen} /></TableIconButton>
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </TableSection>
    </Wrapper >
  );
}
export default Payments;
